import { useState, createContext, useEffect, useRef, ReactNode } from 'react'

import { en, sv, no, phrasesList } from "../polyglot/Languages/index"

import Polyglot from "node-polyglot"

import { PolyglotLanguageType } from './languageType'

import { updateCustomerLanguagePref, userHasLanguage } from '../firebase/databaseApi'

import { useCurrentUser } from '../hooks/contexts/currentUserContext';

import { languageList } from '../polyglot/Languages/index'


const getDefaultLanguage = async (customerId: string | undefined) => {
    let hasLanguage;

    if (customerId != null) {
        try {
            hasLanguage = await userHasLanguage(customerId);
        } catch (error) { }
    }

    const defaultLanguage = languageList.includes(hasLanguage) ? hasLanguage : "sv";
    const defaultPhrases = phrasesList[defaultLanguage as PolyglotLanguageType] || phrasesList["sv"];
    return { defaultLanguage, defaultPhrases }
};

const defaultContextValues = {
    activeLanguage: "sv" as PolyglotLanguageType,
    setActiveLanguage: (_: PolyglotLanguageType) => { },
    polyglot: new Polyglot({ phrases: sv })
};

const PolyglotContext = createContext(defaultContextValues);

const PolyglotProvider = ({ children }: { children: ReactNode }) => {
    const currentUser = useCurrentUser()
    const customerId = currentUser?.customer?.id

    //Default fallback language is English
    const [activeLanguage, setActiveLanguage] = useState<PolyglotLanguageType>("sv" as PolyglotLanguageType)
    const [polyglot, setPolyglot] = useState(new Polyglot({ phrases: en }))

    const prevLanguageRef = useRef<PolyglotLanguageType>(activeLanguage);

    //Retrieves and then sets the current language preference, of the active user from the DB
    const setDefaultLanguage = async () => {
        let defaultLanguage;
        let defaultPhrases;

        try {
            ({ defaultLanguage, defaultPhrases } = await getDefaultLanguage(customerId))
        } catch (error) {
            defaultLanguage = "sv"
            defaultPhrases = sv
        }

        setActiveLanguage(defaultLanguage);
        setPolyglot(new Polyglot({ phrases: defaultPhrases }))
    }

    useEffect(() => {
        setDefaultLanguage()
    }, [customerId])

    //Updates DB with new user preferences when the Language is changed. 
    const updateLanguage = async () => {
        /* MOVE THIS OPERATION TO EVENT TRIGGER (instead of useEffect) IF API CALLS  SPIRAL OUT OF CONTROL */
        if (customerId) {
            try {
                await updateCustomerLanguagePref(customerId, activeLanguage)
            } catch (error) { }
        }

    }

    useEffect(() => {
        if (customerId) {
            setPolyglot(new Polyglot({ phrases: phrasesList[activeLanguage] }))
            if (prevLanguageRef.current !== activeLanguage) {
                prevLanguageRef.current = activeLanguage;
                updateLanguage()
            }
        } else {
            //This is needed to make sure language changeing works on, not logged in related screens
            setPolyglot(new Polyglot({ phrases: phrasesList[activeLanguage] }))
        }
    }, [activeLanguage])

    return (
        <PolyglotContext.Provider value={{ activeLanguage, setActiveLanguage, polyglot }}>
            {children}
        </PolyglotContext.Provider>
    )
}

export { PolyglotContext, PolyglotProvider }
